import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  line-height: 1.428;\n  margin-left: 1.428em;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      &:indeterminate {\n        ~ ", " {\n          svg {\n            opacity: 0;\n\n            &:nth-child(3) {\n              opacity: 1;\n              transform: scale(1);\n            }\n          }\n        }\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  &:focus {\n    ~ ", " {\n      ", "\n    }\n  }\n\n  &:checked {\n    ~ ", " {\n      svg {\n        opacity: 0;\n\n        &:nth-child(2) {\n          opacity: 1;\n          transform: scale(1);\n        }\n      }\n    }\n  }\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        opacity: 0;\n        transform: scale(0);\n\n        &:nth-child(2) {\n          opacity: 1;\n          transform: scale(1);\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        display: none;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: visible;\n  position: relative;\n\n  /* ripple effect size - only cover area of the checkmark */\n  &::after {\n    left: ", "px;\n    ", "\n\n    padding-bottom: 4px;\n    width: 4px;\n  }\n\n  svg {\n    fill: ", ";\n    flex-shrink: 0;\n    height: ", "px;\n    opacity: 1;\n    transition: opacity ", ";\n    width: ", "px;\n\n    &:nth-child(n + 2) {\n      margin-left: -", "px; /* be in the same position as StyledUncheckedIcon */\n      opacity: 0;\n      transform: scale(0);\n      transition: opacity ", ", transform ", ";\n    }\n\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin: -", "px;\n      padding: ", "px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: ", ";\n  color: ", ";\n  cursor: ", ";\n  display: flex;\n  font-size: 14px;\n  min-height: ", "px;\n  min-width: ", "px;\n  position: relative;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { VisuallyHiddenElement } from '@scp/ui-shared/theme/resets';
import { withRippleEffect, getFocusedStyle } from '@scp/ui-shared/theme/ripple-effect';
import { color, property, typography } from '@scp/ui-shared/theme/variables';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { getE2eLabel } from '@scp/ui-shared/components/utils';

var E2E_INPUT_SUFFIX = function E2E_INPUT_SUFFIX(type) {
  return "-field-".concat(type || 'input');
};

var TEXT = {
  E2E_LABEL: 'label'
};
var LabelComponent = withoutProps('label', ['size', 'topAlignedLabel', 'hitSlop', 'disabled']);
var Label = styled(LabelComponent)(_templateObject(), function (props) {
  return props.topAlignedLabel ? 'flex-start' : 'center';
}, function (props) {
  return props.disabled ? color.disabled : color.textPrimary;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return !!props.hitSlop && css(_templateObject2(), props.hitSlop, props.hitSlop);
});
var IconsWrapperComponent = withRippleEffect(withoutProps('span', ['size', 'uiOnly', 'disabled']));
var IconsWrapper = styled(IconsWrapperComponent)(_templateObject3(), function (props) {
  return props.size / 2;
}, function (props) {
  return props.uiOnly && css(_templateObject4());
}, function (props) {
  return props.disabled ? color.disabledSwitch : null;
}, function (props) {
  return props.size;
}, property.transition, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, property.transition, property.transition, function (props) {
  return props.uiOnly && props.checked && css(_templateObject5());
});
var InputElement = VisuallyHiddenElement.withComponent('input');
var InputComponent = styled(InputElement)(_templateObject6(), IconsWrapper, function (props) {
  return props.navigatingByKeyboard && getFocusedStyle();
}, IconsWrapper, function (props) {
  return props.hasIndeterminateState && css(_templateObject7(), IconsWrapper);
});
var Input = withRippleEffect(InputComponent, undefined, false);
var Text = styled.span(_templateObject8(), function (props) {
  return props.bold ? typography.fontWeightSemiBold : typography.fontWeightNormal;
});
var SubText = styled(Paragraph).attrs({
  secondary: true,
  italic: true,
  noMargin: true,
  as: 'span'
})(_templateObject9());
var StaticLabel = withoutProps('span', ['size', 'topAlignedLabel', 'hitSlop']);
export function SwitchInputBase(_a) {
  var _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      label = _a.label,
      subLabel = _a.subLabel,
      title = _a.title,
      uncheckedIcon = _a.uncheckedIcon,
      checkedIcon = _a.checkedIcon,
      indeterminateIcon = _a.indeterminateIcon,
      _a$uiOnly = _a.uiOnly,
      uiOnly = _a$uiOnly === void 0 ? false : _a$uiOnly,
      checked = _a.checked,
      id = _a.id,
      _a$hiddenLabel = _a.hiddenLabel,
      hiddenLabel = _a$hiddenLabel === void 0 ? false : _a$hiddenLabel,
      _a$size = _a.size,
      size = _a$size === void 0 ? 24 : _a$size,
      _a$bold = _a.bold,
      bold = _a$bold === void 0 ? false : _a$bold,
      topAlignedLabel = _a.topAlignedLabel,
      value = _a.value,
      inputRef = _a.inputRef,
      hitSlop = _a.hitSlop,
      type = _a.type,
      otherProps = __rest(_a, ["disabled", "label", "subLabel", "title", "uncheckedIcon", "checkedIcon", "indeterminateIcon", "uiOnly", "checked", "id", "hiddenLabel", "size", "bold", "topAlignedLabel", "value", "inputRef", "hitSlop", "type"]);

  var content = React.createElement(React.Fragment, null, React.createElement(IconsWrapper, {
    size: size,
    checked: checked,
    disabled: disabled,
    uiOnly: uiOnly
  }, uncheckedIcon, checkedIcon, indeterminateIcon), React.createElement(Text, {
    bold: bold,
    as: hiddenLabel ? VisuallyHiddenElement : 'span',
    "data-e2e": getE2eLabel(id, "".concat(E2E_INPUT_SUFFIX(type), "-").concat(TEXT.E2E_LABEL))
  }, label, subLabel && React.createElement(SubText, null, subLabel)));
  var sharedLabelProps = {
    size: size,
    topAlignedLabel: topAlignedLabel,
    disabled: disabled,
    title: title,
    hitSlop: hitSlop
  };

  if (uiOnly) {
    return React.createElement(Label, Object.assign({}, sharedLabelProps, {
      as: StaticLabel,
      "data-e2e": getE2eLabel(id, E2E_INPUT_SUFFIX(type))
    }), content);
  }

  return React.createElement(Label, Object.assign({}, sharedLabelProps, {
    htmlFor: id
  }), React.createElement(Input, Object.assign({
    disabled: disabled,
    checked: checked,
    id: id,
    value: value,
    ref: inputRef,
    hasIndeterminateState: !!indeterminateIcon,
    "data-e2e": getE2eLabel(id, E2E_INPUT_SUFFIX(type)),
    type: type
  }, otherProps)), content);
}